module.exports = __webpack_public_path__ + "img/arrow@3x.38739abb.png";